import { Injectable, inject } from '@angular/core';
import { UcMetadataCacheContext } from '../../contexts/uc-metadata-cache.context';
import { ExtensionMobility, Phone } from '../../models/generated/ziroModels';
import { ReplaySubject } from 'rxjs';
import { first } from 'rxjs/operators';

export interface DragNDropUICache {
  buttonTypes: string[];
}

@Injectable({ providedIn: 'root' })
export class DragdropUiContext {
  private ucMetadataCacheContext = inject(UcMetadataCacheContext);

  private _dragnDropSource = new ReplaySubject<DragNDropUICache>(1);
  dragnDropState$ = this._dragnDropSource.asObservable();

  setDeviceMetaDataCache(serverId: number, phone: Phone | ExtensionMobility): void {
    this.ucMetadataCacheContext.state$.pipe(first()).subscribe((ucMetadataCache) => {
      const metaDataCache = ucMetadataCache.cucmDeviceModelMetadataCache[serverId][phone.model];
      let availableFeatures: string[] = [];
      if (!metaDataCache) {
        availableFeatures = [];
      } else if (phone.protocol === 'SIP') {
        availableFeatures = metaDataCache.sipSetting.availableButtonFeatures;
      } else if (phone.protocol === 'SCCP') {
        availableFeatures = metaDataCache.sccpSetting.availableButtonFeatures;
      }
      const deviceObj = {
        buttonTypes: availableFeatures,
      } as DragNDropUICache;
      this._dragnDropSource.next(deviceObj);
    });
  }
}
